export const RESTRICTEDAPIS = [
    'ews-admincodes-api',
    'ews-calendar-api',
    'ews-lookup-api',
    'ews-person-api',
    '/drs'
]